export default [
  {
    path: '/account',
    name: 'account',
    meta: {
      authRequired: true
    },
    props: {
      isStockItem: true
    },
    component: () => import('@/router/views/account/profile/index')
  }
]
